// The websocket backend is deployed server by server: up to date servers expose
// Mayday::ChatChannel, while the ones still running the previous release only
// know its former name, Mayday::BeneficiaryChannel. The two classes were merged
// server side in a single commit, so a given server always exposes one name and
// never both. App.vue subscribes to both names and records here the one that
// answered, because a couple of commands do not exist under the same name — or
// at all — on the legacy channel.
export const CURRENT_CHANNEL = 'Mayday::ChatChannel'
export const LEGACY_CHANNEL = 'Mayday::BeneficiaryChannel'
export const CHANNEL_NAMES = [CURRENT_CHANNEL, LEGACY_CHANNEL]

// Commands the legacy channel answers to under another name: its beneficiary
// geolocation action is missing the second 'i' of "beneficiary".
const LEGACY_COMMAND_NAMES = {
  update_beneficiary_geolocation: 'update_beneficary_geolocation'
}

// Commands the legacy channel does not implement at all. The guided depollution
// ships with the new channel only, so a beneficiary talking to a legacy server
// never receives a guided question to answer in the first place: sending the
// command would only raise an unknown action server side.
const LEGACY_UNSUPPORTED_COMMANDS = ['answer_guided_question']

let activeChannel = null

export const setActiveChannel = (channelName) => {
  activeChannel = channelName
}

export const activeChannelName = () => activeChannel

export const onLegacyChannel = () => activeChannel === LEGACY_CHANNEL

// Name the connected channel actually answers to for this command, or null when
// that channel does not implement it.
export const channelCommand = (commandName) => {
  if (!onLegacyChannel()) {
    return commandName
  }

  if (LEGACY_UNSUPPORTED_COMMANDS.includes(commandName)) {
    return null
  }

  return LEGACY_COMMAND_NAMES[commandName] || commandName
}
